/* eslint-disable no-restricted-syntax, no-await-in-loop, no-case-declarations */
import * as assetsApiService from '@/services/assets-api/assetsApiService';
import {
  AssetsNamespaces,
  AssetsResponse,
  AssetsSubNamespaces,
} from '@/services/assets-api/assetsClient';
import { documentMimeTypes, imageMimeTypes, videoMimeTypes, audioMimeTypes } from '@/services/assets-api/assetsValidation';

export enum AssetsDocumentActions {
  ADD_DOCUMENT = 'add_document',
  DELETE_DOCUMENT = 'delete_document',
}

export interface AssetsDocumentStub {
  file?: File | null;
  file_id: string;
  file_name: string;
  file_type: 'documents' | 'images' | 'videos' | 'audios';
  file_size: number | null;
  action?: AssetsDocumentActions;
}

export const getDocumentStub = (): AssetsDocumentStub => ({
  file: null,
  file_id: '',
  file_name: '',
  file_size: null,
  file_type: 'documents',
});

export interface AssetsDocumentStubActionable extends AssetsDocumentStub {
  file_id_delete?: string | null;
}

export const processDocument = async (item: AssetsDocumentStubActionable, validateFile = true) => {
  switch (item.action) {
    case AssetsDocumentActions.DELETE_DOCUMENT:
      const id = item.file_id_delete || item.file_id;
      if (id) {
        await assetsApiService.removeDocument(id);
      }
      break;
    case AssetsDocumentActions.ADD_DOCUMENT:
      const documentUploadResponse = await assetsApiService.uploadDocument(
        {
          file: item.file!,
          namespace: AssetsNamespaces.inspections,
          subnamespace: AssetsSubNamespaces.questions,
        },
        validateFile,
      );

      if (!documentUploadResponse) {
        throw new Error();
      }
      item.file_id = (documentUploadResponse as AssetsResponse).id!;
      item.file_name = (documentUploadResponse as AssetsResponse).fileName!;
      if (documentMimeTypes.includes(getFileType(item))) {
        item.file_type = 'documents';
      }
      if (imageMimeTypes.includes(getFileType(item))) {
        item.file_type = 'images';
      }
      if (videoMimeTypes.includes(getFileType(item))) {
        item.file_type = 'videos';
      }
      if (audioMimeTypes.includes(getFileType(item))) {
        item.file_type = 'audios';
      }
      break;
    default:
  }

  delete item.action;
  delete item.file;
  return item;
};

export const processFile = async (item: AssetsDocumentStub) => {
  const { action } = item;
  const processedItem = await processDocument(item, false);

  return action !== AssetsDocumentActions.DELETE_DOCUMENT
    ? processedItem
    : null;
};

const getFileType = (item :AssetsDocumentStub) => {
  return item.file?.type as string;
};
